const featureFlagEnableDigitalAccess = 'enableDigitalAccess';
export const featureFlagEnableWeeklyDigital = 'enableWeeklyDigital';
export function getFeatureFlags() {
    const urlParams = new URLSearchParams(window.location.search);
    return {
        enableDigitalAccess: urlParams.has(featureFlagEnableDigitalAccess),
        enableWeeklyDigital: urlParams.has(featureFlagEnableWeeklyDigital),
    };
}
